import React from 'react';
import PropTypes from 'prop-types';
import { ComponentClassNames } from '../../../../../helper/componen_class_names';

function LightboxViewContent({ isDefault, children }) {
    const containerClassNames = new ComponentClassNames(
        'lightbox-filter-view__filter-section',
        'lightbox-filters-content'
    );

    if (!isDefault) {
        containerClassNames.addClassNames('lightbox-filters-content--non-default');
    }

    return (
        <div className={containerClassNames.getClassName()}>
            {children}
        </div>
    );
}

LightboxViewContent.propTypes = {
    isDefault: PropTypes.bool
};

LightboxViewContent.defaultProps = {
    isDefault: false
};

export { LightboxViewContent };
